var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.colors.length > 1
    ? _c("div", { staticClass: "color-index align-self-center" }, [
        _c("div", { staticClass: "ob1-color-chips ob1-color-chips-mini" }, [
          _c("span", { staticClass: "visually-hidden" }, [
            _vm._v("Groupe de couleurs disponibles non sélectionnables"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            [
              _vm._l(_vm.allColors(), function (color) {
                return [
                  _c(
                    "div",
                    {
                      key: color.colorName,
                      staticClass: "ob1-color-chip",
                      style: "background-color: " + color.code + ";",
                    },
                    [
                      _c("span", {
                        staticClass: "ob1-color-chips-mini-tooltip",
                        domProps: { innerHTML: _vm._s(color.colorName) },
                      }),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }